export const rolesList = [
  'ADM - TI',
  'ADM',
  'APOIO',
  'AUDITOR',
  'AVALIADOR',
  'COORDENADOR',
  'ENGENHARIA',
  'MECÂNICO',
  'PCP',
  'VISUALIZADOR',
];

// Perfis com acesso à gestão de configurações (usuários, bases, oficinas, etc.)
export const settingRolesList = ['ADM - TI', 'ADM'];

// Perfis com acesso à gestão de serviços
export const serviceRolesList = ['ADM - TI', 'ADM', 'ENGENHARIA', 'PCP'];

export const rolesDescriptions = {
  'ADM - TI': '	Administrador do sistema (possui todas as permissões)',
  ADM: 'Administrador (possui todas as permissões - exceto adição de usuários)',
  // 'Coordenador (pode inserir e atualizar as situações das aeronaves/ver relatórios)',
  COORDENADOR:
    'Coordenador (possui as mesmas permissões de Visualizador e Auditor)',
  ENGENHARIA:
    'Engenharia (pode inserir e atualizar as situações das aeronaves/ver relatórios)',
  VISUALIZADOR: 'Visualizador (apenas visualização do dashboard/relatórios)',
  PCP: 'Responsável por importação de planilhas de serviços',
  'AUDITOR RIF': 'Auditor de segurança de organização de manutenção',
  /* AVALIADOR: 'Avaliador', */
  MECÂNICO: 'Mecânico',
  APOIO: 'Apoio',
};
